<template>
  <div class="p-formgrid p-grid">    
      
    <TabView>          
      <TabPanel header="Normais">
        <h6 class="p-text-bold">Faixas normais <span class="campo-obrigatorio">*</span></h6>
        <DataTable :value="faixasNormais" editMode="cell" class="p-datatable-sm editable-cells-table">    
          <template #header>
              <div class="table-header">                    
                  <Button icon="pi pi-plus" label="Nova" @click="incluirFaixa(1)"/>
              </div>
          </template>        
          <Column field="ate" header="Até">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.ate" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>          
          <Column field="segunda" header="Seg (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.segunda" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="terca" header="Ter (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.terca" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="quarta" header="Qua (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.quarta" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="quinta" header="Qui (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.quinta" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="sexta" header="Sex (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.sexta" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="sabado" header="Sábados (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.sabado" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="domingo" header="Domingos (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.domingo" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="folga" header="Folgas (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.folga" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="feriado" header="Feriados (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.feriado" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>  
          <Column>
            <template #body="slotProps">                
              <Button @click="excluirFaixa(slotProps.data)" title="Excluir" icon="pi pi-trash" class="p-button-rounded p-button-danger"/>
            </template>
          </Column>         
        </DataTable>  
      </TabPanel>
      
      <TabPanel header="Noturnas">
        <h6 class="p-text-bold">Faixas noturnas</h6>
        <DataTable :value="faixasNoturnas" editMode="cell" class="p-datatable-sm editable-cells-table">
          <template #header>
              <div class="table-header">                    
                  <Button icon="pi pi-plus" label="Nova" @click="incluirFaixa(2)"/>
              </div>
          </template>        
          <Column field="ate" header="Até">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.ate" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="segunda" header="Seg (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.segunda" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="terca" header="Ter (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.terca" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="quarta" header="Qua (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.quarta" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="quinta" header="Qui (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.quinta" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="sexta" header="Sex (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.sexta" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="sabado" header="Sábados (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.sabado" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="domingo" header="Domingos (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.domingo" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="folga" header="Folgas (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.folga" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>
          <Column field="feriado" header="Feriados (%)">
            <template #editor="slotProps">
                <InputText type="number" v-model.number="slotProps.data.feriado" class="p-col-12 input-datatable-editavel"/>
            </template>
          </Column>  
          <Column>
            <template #body="slotProps">
              <Button @click="excluirFaixa(slotProps.data)" title="Excluir" icon="pi pi-trash" class="p-button-rounded p-button-danger"/>
            </template>
          </Column> 
        </DataTable>            
      </TabPanel>
    </TabView>
  
    <div class="p-field p-col-12 p-md-12 p-mt-5">
      <h6 class="p-text-bold">Tolerância <span class="campo-obrigatorio">*</span></h6>
      <div class="p-fluid p-formgrid p-grid">        
        <div class="p-field p-col-2 p-md-2">
          <label>Minutos</label>
          <InputText type="number" v-model="politicaHoraExtra.toleranciaInicioHoraExtra" min="0"/>
        </div>       
      </div>            
    </div>

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Primeiro intervalo</h6>
      <div class="p-field-checkbox">
        <Checkbox v-model="politicaHoraExtra.descontoDSRFeriado" :binary="true"/>
        <label for="city1">Desconto DSR/Feriado > 6</label>
      </div>
    </div>

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Horas Extras nas Refeições</h6>
      <div class="p-field-checkbox">
        <Checkbox v-model="politicaHoraExtra.horaExtraRefeicao" :binary="true"/>
        <label for="city1">Horas Extras nas Refeições</label>
      </div>
    </div>

  </div>
</template>

<script>
import PoliticaHoraExtra from '@/model/PoliticaHoraExtra';
import FaixaHoraExtra from '@/model/FaixaHoraExtra';
import { clonar } from '@/global';

export default {
  data() {
    return {     
      tituloModal: 'Nova faixa normal',      
      exibirDialogCadastro: false,
      politicaHoraExtra: new PoliticaHoraExtra(),
      faixasNormais: [],
      faixasNoturnas: [],
      faixasExcluidas: [],
    }
  },
  methods: {   
    incluirFaixa(tipo) {
      let faixa = new FaixaHoraExtra();     
      faixa.tipo = tipo;
      if(tipo == 1) {
        this.faixasNormais.push(faixa);
      } else {// 2
        this.faixasNoturnas.push(faixa);
      }
    },
    excluirFaixa(faixa) {  
      // Somente quando for uma edição
      if(faixa.id != null) {
        this.faixasExcluidas.push({...faixa});
      }  
      if(faixa.tipo == 1) {
        this.faixasNormais.splice(this.faixasNormais.indexOf(faixa), 1);
      } else {// 2
        this.faixasNoturnas.splice(this.faixasNoturnas.indexOf(faixa), 1);
      }      
    },
    setConfiguracao(politicaHoraExtra, faixas) {     
      this.politicaHoraExtra = politicaHoraExtra;
      this.faixasNormais = [];
      this.faixasNoturnas = [];
      faixas.forEach(faixa => {
        this.calcularPercentual(faixa, '*');
        if(faixa.tipo == 1) {
          this.faixasNormais.push(faixa);
        } else {
          this.faixasNoturnas.push(faixa);
        }
      });
    },
    getConfiguracao() {
      if(this.faixasNormais.length == 0) {
        throw 'Horas extras: Cadastre no minimo uma faixa de valores';
      } 
      this.faixasNormais.forEach(faixa => {
        if(isNaN(faixa.ate) || isNaN(faixa.segunda) || isNaN(faixa.terca) 
        || isNaN(faixa.quarta) || isNaN(faixa.quinta) || isNaN(faixa.sexta)
        || isNaN(faixa.sabado) || isNaN(faixa.domingo) || isNaN(faixa.feriado) 
        || isNaN(faixa.folga)) {
          throw 'Horas extras - Faixa normal: Informe todos os campos da faixa';
        }
      });
      this.faixasNoturnas.forEach(faixa => {
        if(isNaN(faixa.ate) || isNaN(faixa.segunda) || isNaN(faixa.terca) 
        || isNaN(faixa.quarta) || isNaN(faixa.quinta) || isNaN(faixa.sexta)
        || isNaN(faixa.sabado) || isNaN(faixa.domingo) || isNaN(faixa.feriado) 
        || isNaN(faixa.folga)) {
          throw 'Horas extras - Faixa noturna: Informe todos os campos da faixa';
        }
      });
      if(isNaN(this.politicaHoraExtra.toleranciaInicioHoraExtra)) {
        throw 'Horas extras: Informe os campos obrigatórios';
      }
      let faixas = clonar(this.faixasNormais);     
      this.faixasNoturnas.forEach(faixa => {
        faixas.push({...faixa});
      });
      faixas.forEach(faixa => {
        this.calcularPercentual(faixa, '/');
      });
      let configuracao = {
        faixas: faixas,
        faixasExcluidas: this.faixasExcluidas,
        politicaHoraExtra: {...this.politicaHoraExtra}
      }
      return configuracao;
    },
    criarFaixasValorDefault() {           
      let faixaNormal = new FaixaHoraExtra();
      // 1 normal, 2 noturna           
      faixaNormal.tipo = 1;
      faixaNormal.ate = 99;
      faixaNormal.segunda = 50;
      faixaNormal.terca = 50;
      faixaNormal.quarta = 50;
      faixaNormal.quinta = 50;
      faixaNormal.sexta = 50;
      faixaNormal.sabado = 50;
      faixaNormal.domingo = 100;
      faixaNormal.feriado = 100;
      faixaNormal.folga = 100;
      this.faixasNormais.push(faixaNormal);        
    },
    calcularPercentual(faixa, operador) {       
      if(!isNaN(faixa.segunda)) {
        if(operador == '/') {
          faixa.segunda = faixa.segunda / 100;
        } else {
          faixa.segunda = faixa.segunda * 100;
        }
      }
      if(!isNaN(faixa.terca)) {
        if(operador == '/') {
          faixa.terca = faixa.terca / 100;
        } else {
          faixa.terca = faixa.terca * 100;
        }
      }
      if(!isNaN(faixa.quarta)) {
        if(operador == '/') {
          faixa.quarta = faixa.quarta / 100;
        } else {
          faixa.quarta = faixa.quarta * 100;
        }
      }
      if(!isNaN(faixa.quinta)) {
        if(operador == '/') {
          faixa.quinta = faixa.quinta / 100;
        } else {
          faixa.quinta = faixa.quinta * 100;
        }
      }
      if(!isNaN(faixa.sexta)) {
        if(operador == '/') {
          faixa.sexta = faixa.sexta / 100;
        } else {
          faixa.sexta = faixa.sexta * 100;
        }
      }
      if(!isNaN(faixa.sabado)) {
        if(operador == '/') {
          faixa.sabado = faixa.sabado / 100;
        } else {
          faixa.sabado = faixa.sabado * 100;
        }          
      }
      if(!isNaN(faixa.domingo)) {        
        if(operador == '/') {
          faixa.domingo = faixa.domingo / 100;
        } else {
          faixa.domingo = faixa.domingo * 100;
        }
      }
      if(!isNaN(faixa.feriado)) {
        if(operador == '/') {
          faixa.feriado = faixa.feriado / 100;
        } else {
          faixa.feriado = faixa.feriado * 100;
        }        
      }
      if(!isNaN(faixa.folga)) {
        if(operador == '/') {
          faixa.folga = faixa.folga / 100;
        } else {
          faixa.folga = faixa.folga * 100;
        }   
      }
    }
  }, 
  created() {
    this.criarFaixasValorDefault();
    // Valores default para um item novo
    this.politicaHoraExtra.toleranciaInicioHoraExtra = 10;
    this.politicaHoraExtra.prioridadeHoraExtra = 2;
    this.politicaHoraExtra.horaExtraRefeicao = true;
  }
}
</script>

<style>

  .input-datatable-editavel {
    height: 30px !important;
  }

</style>